import React from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';

const ExpenseComments = (props) => {
    const { index, expense, isPosted, isPendingSubmission, isViewOnly } = props;
    const { control, watch, errors } = useFormContext();
    const expenseType = watch(`expenseEntries[${index}].type`);
    const expenseCategory = watch(`expenseEntries[${index}].category`);
    const isRequiredType =
        (expenseCategory === 'Travel' && expenseType === 'Misc') ||
        expenseType === 'ComplianceFees';

    return (
        <Grid2 item size={{ xs: 12 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].accountingProcessingNotes`}
                defaultValue={expense.accountingProcessingNotes}
                rules={{
                    required: isRequiredType ? 'Expense comments are required' : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required={isRequiredType}
                        multiline
                        inputProps={{ maxLength: 1000 }}
                        minRows={5}
                        id={`accounting-processing-notes${index}`}
                        onChange={onChange}
                        value={value}
                        label="Accounting Processing Notes"
                        error={Boolean(errors.expenseEntries?.[index]?.accountingProcessingNotes)}
                        disabled={
                            (isPosted && isViewOnly) ||
                            (isPendingSubmission && isViewOnly) ||
                            isViewOnly
                        }
                        helperText={
                            errors.expenseEntries?.[index]?.accountingProcessingNotes?.message
                                ? errors.expenseEntries?.[index]?.accountingProcessingNotes?.message
                                : value && `${value.length}/1000`
                        }
                        placeholder="Enter notes for the Accounting System"
                        slotProps={{
                            input: {
                                sx: {
                                    height: 'auto', // Allow auto height
                                    fontSize: '14px',
                                    padding: '10px 12px !important',
                                },
                            },
                        }}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: '0',
                            },
                            '& .MuiInputLabel-shrink': {
                                transform: 'translate(0, 1.5px) scale(0.75) !important',
                            },
                            '& .MuiInputBase-root::before': { borderBottom: 'none !important' }, // Removes default underline
                            '& .MuiInputBase-root::after': { borderBottom: 'none !important' }, // Prevents focus underline
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseComments;
